import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Joyride from "react-joyride";

const Tour = ({ page, showAgainHelp }) => {
  const { t, i18n } = useTranslation();
  const [isTour, setIsTour] = useState(
    JSON.parse(localStorage.getItem("isTour")) || ""
  );

  const customStyle = {
    options: {
      arrowColor: "#1e90ff",
      backgroundColor: "#1e90ff",
      textColor: "#fff",
      zIndex: 9999,
    },
    tooltipTitle: {
      fontSize: 18,
      color: "#fff",
    },
    buttonNext: {
      backgroundColor: "#ffbb00",
      color: "#fff",
    },
    buttonBack: {
      color: "#fff",
    },
    beaconInner: {
      backgroundColor: "#ffbb00",
    },
    beaconOuter: {
      border: `2px solid #ffbb00`,
    },
    tooltip: {
      direction: i18n.dir(),
    },
    buttonClose: {
      left: i18n.dir() === "rtl" ? "" : 0,
      right: i18n.dir() === "rtl" ? 0 : "",
    },
  };

  const tourSteps = {
    users: [
      {
        target: ".users-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_one"),
      },
      {
        target: ".users-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_two"),
      },
      {
        target: ".users-step-three",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_three"),
      },
      {
        target: ".users-step-four",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_four"),
      },
      {
        target: ".users-step-five",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_five"),
      },
      {
        target: ".users-step-six",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_six"),
      },
      {
        target: ".users-step-seven",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.user_step_seven"),
      },
    ],
    groups: [
      {
        target: ".groups-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_one"),
      },
      {
        target: ".groups-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_two"),
      },
      {
        target: ".groups-step-three",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_three"),
      },
      {
        target: ".groups-step-four",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_four"),
      },
      {
        target: ".groups-step-five",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_five"),
      },
      {
        target: ".groups-step-six",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.group_step_six"),
      },
    ],
    userInGroup: [
      {
        target: ".userInGroup-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.userInGroup_step_one"),
      },
      {
        target: ".userInGroup-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.userInGroup_step_two"),
      },
    ],
    userGroups: [
      {
        target: ".userGroups-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.userGroups_step_one"),
      },
      {
        target: ".userGroups-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.userGroups_step_two"),
      },
    ],
    dispatch: [
      {
        target: ".dispatch-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.dispatch_step_one"),
      },
      {
        target: ".dispatch-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.dispatch_step_two"),
      },
      {
        target: ".dispatch-step-three",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.dispatch_step_three"),
      },
      {
        target: ".dispatch-step-four",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.dispatch_step_four"),
      },
    ],
    notifications: [
      {
        target: ".notifications-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.notification_step_one"),
      },
      {
        target: ".notifications-step-two",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.notification_step_two"),
      },
    ],
    missions: [
      {
        target: ".missions-step-one",
        disableBeacon: true,
        offset: 0,
        title: t("tour.step_title"),
        content: t("tour.mission_step_one"),
      },
    ],
  };

  useEffect(() => {
    if (showAgainHelp?.value) {
      localStorage.setItem(
        "isTour",
        JSON.stringify({ ...isTour, [showAgainHelp?.value]: true })
      );
      setIsTour(JSON.parse(localStorage.getItem("isTour")) || "");
    }
  }, [showAgainHelp?.isChange]);

  const handleCallback = (e) => {
    if (page && e.action === "close") {
      setIsTour({ ...isTour, [page]: false });
      localStorage.setItem(
        "isTour",
        JSON.stringify({ ...isTour, [page]: false })
      );
    }
    if (page && e.status === "finished") {
      localStorage.setItem(
        "isTour",
        JSON.stringify({ ...isTour, [page]: false })
      );
      setIsTour(JSON.parse(localStorage.getItem("isTour")) || "");
    }
  };

  return (
    <Joyride
      disableOverlayClose
      key={tourSteps[page]}
      steps={tourSteps[page]}
      autoStart={true}
      continuous={true}
      styles={customStyle}
      showProgress={true}
      callback={handleCallback}
      run={isTour[page]}
      locale={{
        back: t("tour.back_title"),
        close: t("tour.close_title"),
        last: t("tour.last_title"),
        next: t("tour.next_title"),
        skip: t("tour.skip_title"),
      }}
    />
  );
};

export default Tour;
